<template>
  <div class="hc-accordion" data-testid="hc-accordion-root">
    <div
      v-for="(panel, index) in panels"
      :key="index"
      class="hc-accordion__item"
      :class="{ 'is-open': isOpen(index) }"
    >
      <button
        :id="headerId(index)"
        type="button"
        class="hc-accordion__header"
        :aria-expanded="isOpen(index) ? 'true' : 'false'"
        :aria-controls="panelId(index)"
        :data-testid="`hc-accordion-header-${index}`"
        @click="toggle(index)"
      >
        <span class="hc-accordion__title">{{ panel.title }}</span>
        <svg
          class="hc-accordion__icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      <div
        :id="panelId(index)"
        class="hc-accordion__panel"
        role="region"
        :aria-labelledby="headerId(index)"
        :aria-hidden="isOpen(index) ? 'false' : 'true'"
      >
        <div class="hc-accordion__panel-inner">
          <div
            v-if="panel.content"
            v-dompurify-html="panel.content"
            class="hc-accordion__content"
          />
          <ul
            v-if="panel.items && panel.items.length"
            class="hc-accordion__items"
          >
            <li v-for="(item, itemIndex) in panel.items" :key="itemIndex">
              <a v-if="item.link" :href="item.link">{{ item.text }}</a>
              <span v-else>{{ item.text }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Accessible, animated accordion. Content is rendered through v-dompurify-html
// (globally configured) so only sanitized markup reaches the DOM.

// Header/panel ids must be unique per instance so aria-controls and
// aria-labelledby stay correct when several accordions share a page.
let instanceCount = 0;

export default {
  name: 'AccordionBlock',
  props: {
    config: { type: Object, default: () => ({}) },
  },
  data() {
    instanceCount += 1;
    return {
      instanceId: instanceCount,
      openState: this.panelList().map(panel => panel.open === true),
    };
  },
  computed: {
    panels() {
      return this.panelList();
    },
  },
  methods: {
    panelList() {
      const panels = this.config && this.config.panels;
      return Array.isArray(panels) ? panels : [];
    },
    isOpen(index) {
      return this.openState[index] === true;
    },
    toggle(index) {
      this.$set(this.openState, index, !this.openState[index]);
    },
    headerId(index) {
      return `hc-accordion-header-${this.instanceId}-${index}`;
    },
    panelId(index) {
      return `hc-accordion-panel-${this.instanceId}-${index}`;
    },
  },
};
</script>

<style src="./styles/AccordionBlock.scss" lang="scss" scoped></style>
